module.exports = __webpack_public_path__ + "static/media/foto_4.eb1b7298.png";